import React from 'react';
import { N30, N700 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var IconContainer = styled.span({
  background: "var(--ds-background-neutral, ".concat(N30, ")"),
  height: "var(--ds-space-300, 24px)",
  borderRadius: "var(--ds-border-radius-400, 4px)",
  border: "'1px solid transparent'",
  color: "var(--ds-icon-subtle, ".concat(N700, ")"),
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  display: 'flex',
  alignItems: 'center',
  padding: "0 ".concat("var(--ds-space-075, 6px)")
});
export var ControlIcon = function ControlIcon() {
  return /*#__PURE__*/React.createElement(IconContainer, null, "Ctrl");
};